module.exports = __webpack_public_path__ + "img/Payment_fail_illustration.2aca56ba.svg";